import { apiGet, apiPost, apiPut } from '../_common';

export default {
  create(request) {
    return apiPost('/magenta/billing/coupon', request).then(result => result.response);
  },
  update(id, request) {
    return apiPut(`/magenta/billing/coupon/${id}`, request).then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/billing/coupon', query).then(result => result.response);
  },
  getCouponById(id) {
    return apiGet(`/magenta/billing/coupon/${id}`).then(result => result.response);
  },
};
